import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import keshroot from "../../Assets/Projects/keshroot.png";
import zerozero from "../../Assets/Projects/zerozero.png";
import btxHub from "../../Assets/Projects/btHub.webp";
import propetro from "../../Assets/Projects/propetro.png";
import skeeus from "../../Assets/Projects/skeeus.png";
import edeacode from "../../Assets/Projects/edeacode.jpeg";
import TIS from "../../Assets/Projects/TIS.png";
import ssi from "../../Assets/Projects/ssi.png";
import vru from "../../Assets/Projects/vru.svg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={keshroot}
              isBlog={false}
              title="Keshroot"
              description="Nourish your hair with the power of 13 rich  ingredients Say goodbye to dry, dull hair with Keshroot Hair Oil's powerful formula Your hair care partner for life, Keshroot Hair Oil"
              demoLink="https://www.keshroot.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={zerozero}
              isBlog={false}
              title="ZeroZero Hair Removal Cream"
              description="Zero Zero is a brand that truly believes that women should feel confident and comfortable in their skin."
              demoLink="https://www.zerozeroindia.com/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={btxHub}
              isBlog={false}
              title="BTX Hub"
              description="BTX SharePoint Intranet Pages Designs and Power Automate Automations."
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={edeacode}
              isBlog={false}
              title="Edea Code"
              description="Created and maintained end-to-end solutions leveraging Power Apps, Power Automate, SharePoint, Power BI, Dataverse, Azure, and SQL Server, with experience in SharePoint migrations using ShareGate and custom development with SPFx."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={skeeus}
              isBlog={false}
              title="SKEEUS"
              description="Led the design, development, and maintenance of enterprise solutions across Power Apps, Power Automate, SharePoint, Power BI, Dataverse, Azure, and SQL Server, including SharePoint migrations using ShareGate and custom SPFx development."
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={propetro}
              isBlog={false}
              title="ProPetro"
              description="Designed, created, and maintained various Power Apps solutions and Power Automate automations."
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={TIS}
              isBlog={false}
              title="Torus IT Solutions"
              description="Created and maintained end-to-end solutions leveraging Power Apps, Power Automate, SharePoint, Power BI, Dataverse, Azure, and SQL Server, with experience in SharePoint migrations using ShareGate and custom development with SPFx."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ssi}
              isBlog={false}
              title="Sai Systems International"
              description="Led the design, development, and maintenance of enterprise solutions across Power Apps, Power Automate, SharePoint, Power BI, Dataverse, Azure, and SQL Server, including SharePoint migrations using ShareGate and custom SPFx development."
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={vru}
              isBlog={false}
              title="VRUtel"
              description="Designed, created, and maintained various Power Apps solutions and Power Automate automations."
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
